export const listStatus = [
  { textStatus: 'Pendiente', valueStatus: 'P' },
  { textStatus: 'Devuelta', valueStatus: 'DEVUELTA' },
  { textStatus: 'Recibida', valueStatus: 'RECIBIDA' },
  { textStatus: 'Autorizada', valueStatus: 'AUTORIZADO' },
  { textStatus: 'No Autorizada', valueStatus: 'NO_AUTORIZADO' },
  { textStatus: 'Notificado', valueStatus: 'NOTIFICADO' },
  { textStatus: 'Todas', valueStatus: '' },
]

export const listStatusFilters = [
  { textStatus: 'Pendiente cambio de Fecha', valueStatus: 'PCF' }, 
  { textStatus: 'Pendiente', valueStatus: 'P' }, 
  { textStatus: 'Devuelta', valueStatus: 'DEVUELTA' },
  { textStatus: 'Recibida', valueStatus: 'RECIBIDA' },
  { textStatus: 'Autorizada', valueStatus: 'AUTORIZADO' },
  { textStatus: 'No Autorizada', valueStatus: 'NO_AUTORIZADO' },
  { textStatus: 'Notificado', valueStatus: 'NOTIFICADO' },
  { textStatus: 'No Notificado', valueStatus: 'NO_NOTIFICADO' },
]

export const listStatusUnprocessedFilters = [
  { textStatus: 'Pendiente cambio de Fecha', valueStatus: 'PCF' }, 
  { textStatus: 'Pendiente', valueStatus: 'P' }, 
  { textStatus: 'Devuelta', valueStatus: 'DEVUELTA' },
  { textStatus: 'No Autorizada', valueStatus: 'NO_AUTORIZADO' },
]

export const listStatusXml = [
  { textStatus: 'XML Hiopos', valueStatus: 'hiopos' },
  { textStatus: 'XML Autorizados', valueStatus: 'autorizado' },
]
